import { ProjectType } from '@prisma/client';

export const API_DEFAULT_CARBON_AVOIDANCE_PROJECT_TYPE = ProjectType.CAPTURE;
export const API_DEFAULT_CARBON_REMOVAL_PROJECT_TYPE = ProjectType.BIOCHAR;
export const API_DEFAULT_HABITAT_RESTORATION_PROJECT_TYPE = ProjectType.WILDFLOWERS;
